const getEnvVars = {
    environment: process.env.NODE_ENV || 'Environment is not set',
    version: process.env.REACT_APP_VERSION || 'Version is unknown',
    oidc: {
        url: process.env.REACT_APP_OIDC_BASE_URL || 'OIDC base url is unknown',
        realm: process.env.REACT_APP_OIDC_REALM || 'OIDC realm is unknown',
        clientId: process.env.REACT_APP_OIDC_CLIENT_ID || 'OIDC client id is not set',
    },
    calcService: {
        uploads: {
            packageTypes: process.env.REACT_APP_CALC_UPLOADS_PACKAGE_TYPES || 'Package types upload url is unknown',
            materials: process.env.REACT_APP_CALC_UPLOADS_MATERIALS || 'Materials upload url is unknown',
            storage_structure: process.env.REACT_APP_CALC_UPLOADS_STORAGE_STRUCTURE || 'Storage structure upload url is unknown',
            customerGroupAssignments: process.env.REACT_APP_CALC_UPLOADS_CUSTOMER_ASSIGNMENTS || 'Customer assignment upload url is unknown',
        }
    },
    bff: {
        host: process.env.REACT_APP_CORE_HOST || ' Core host was not defined',
        url: process.env.REACT_APP_CORE_BASE_URL || 'BFF base url is unknown',
    },
}

export default getEnvVars
